@if (sizeType.options.length) {
@if (sizeType.title) {
<p class="s2">{{sizeType.title | translate}}</p>
}

<div class="m-t flex flex-wrap"
     style="gap: 8px;">
    @for (size of orderedSizeOptions; track size) {
    <button type="button"
            class="_size-option"
            [class._selected]="isSelected(size)"
            (click)="selectSize(size)">
        {{size | optionLabel : 'size'}}
    </button>
    }
</div>
}